import { useState } from "react";
import { useInsights } from "../../hooks/useInsights";
import { useCommunityInsights } from "../../hooks/useCommunityInsights";
import { PeriodPicker } from "../../components/molecules/PeriodPicker/PeriodPicker";
import { KeyStatistics } from "../insights/KeyStatistics";
import { MostAffectedCommunities } from "../insights/MostAffectedCommunities";
import { LoadingSkeleton } from "../../components/atoms/LoadingSkeleton/LoadingSkeleton";
import { ErrorMessage } from "../../components/atoms/ErrorMessage/ErrorMessage";
import "./InsightsTab.css";

function getDefault7DayRange() {
  const end = new Date();
  const start = new Date();
  start.setDate(end.getDate() - 7);
  start.setHours(0, 0, 0, 0);
  end.setHours(23, 59, 59, 999);

  const toLocal = (d: Date) =>
    d
      .toLocaleString("en-CA", {
        timeZone: "America/Halifax",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      })
      .replace(", ", "T");

  return { start: toLocal(start), end: toLocal(end) };
}

export function InsightsTab() {
  const [dateRange, setDateRange] = useState(getDefault7DayRange);
  const { data, isLoading, error, isFetching } = useInsights(
    dateRange.start,
    dateRange.end,
  );
  const { data: communityData, isLoading: communityLoading, error: communityError, isFetching: communityFetching } = useCommunityInsights(
    dateRange.start,
    dateRange.end,
  );

  const handleDateChange = (start, end) => {
    setDateRange({ start, end });
  };

  return (
    <section className="App-section">
      <PeriodPicker
        startDate={dateRange.start}
        endDate={dateRange.end}
        onDateChange={handleDateChange}
        isLoading={isFetching || communityFetching}
      />

      {isLoading && <LoadingSkeleton variant="text" />}

      {error && <ErrorMessage message={error.message} />}

      {data && (
        <KeyStatistics
          statistics={data.statistics}
          comparisons={data.comparisons.vsPreviousPeriod}
        />
      )}

      {communityLoading && <LoadingSkeleton variant="text" />}

      {communityError && <ErrorMessage message={communityError.message} />}

      {communityData && (
        <MostAffectedCommunities
          communities={communityData.communities}
          periodLabel={communityData.period.label}
        />
      )}
    </section>
  );
}
